import { render, staticRenderFns } from "./MaxTextCounter.vue?vue&type=template&id=4e1c6bc8&lang=pug"
import script from "./MaxTextCounter.vue?vue&type=script&lang=js"
export * from "./MaxTextCounter.vue?vue&type=script&lang=js"
import style0 from "./MaxTextCounter.vue?vue&type=style&index=0&id=4e1c6bc8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports